import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.TwoFaProfileEnabling.Actions', {
    title: 'Install Authentication app to log in',
    buttonNext: 'Next',
    buttonPrev: 'Back',
});
